export function setReservas(state, reservas) {
    state.reservas = reservas;
    state.reservas.forEach(element => {
        element.hide = false
    });
}

export function setReservaSelec(state, reserva) {
    state.reservaSelec = reserva;
}

export function setReservasCalendario(state, data) {
    state.reservasCalendario = data.reservas;
    state.tallerCalendario = data.taller;
    
    for (let index = 0; index < state.reservasCalendario.length; index++) {
        const res = state.reservasCalendario[index];
        state.reservasCalendario[index].color ='#'+(Math.random() * 0xFFFFFF << 0).toString(16).padStart(6, '0');
    }
}

export function setDisponibilidadAnual(state, dispo) {
    state.disponibilidadAnual = dispo.disponibilidad;
}

export function setDialogWidth(state, width) {
    state.dialogWidth = width
}

export function setRutaSelec(state, rutaSelec) {
    state.rutaSelec = rutaSelec;
    if (state.rutaSelec != null && state.fechaSelec != null) {
        state.dialogWidth = '1400px';
    } else {
        state.dialogWidth = '600px';
    }
}

export function setFechaSelec(state, fechaSelec) {
    state.fechaSelec = fechaSelec;
    if (state.rutaSelec != null && state.fechaSelec != null) {
        state.dialogWidth = '1400px';
    } else {
        state.dialogWidth = '600px';
    }
}

export function setPagado(state, pagado) {
    state.pagado = pagado;
}

export function setPendiente(state, pendiente) {
    state.pendiente = pendiente;
}

export function setFrom(state, from) {
    state.from = from;
}

export function setUntil(state, until) {
    state.until = until;
}



export function reiniciarTarifas(state) {
    if (state.rutaSelec != null){
        state.rutaSelec.tarifas.forEach(element => {
            element.pax = 0;
        });
    }
    
}



export function actDeleteListReservas(state, id) {
    if (id != null) {


        for (let index = 0; index < state.reservas.length; index++) {
            const res = state.reservas[index];
            if (res.id == id){
                state.reservas.splice(index, 1);
            }
        }


        const index = state.reservas.findIndex(r => r.id == id)
        if (index != -1) {
            state.reservas.splice(index, 1);
        }
    }
}